// (cookies module only: constants are imported everywhere, also by Cypress)
import { cookieNamesForDomain } from "../shared/session/cookies";

interface RoutesItem {
  name: string;
  href: string;
  icon: string;
}

export const routes: RoutesItem[] = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: "/images/dashboard.svg",
  },
  {
    name: "Load Execution",
    href: "/load-execution",
    icon: "/images/load-assignment.svg",
  },
  {
    name: "Equipment Availabilty",
    href: "/equipment-availability",
    icon: "/images/truck-green.svg",
  },
  // {
  //   name: "Driver Schedule",
  //   href: "/driver-schedule",
  //   icon: "/images/driver-schedule.svg",
  // },
  {
    name: "Chats",
    href: "/chats",
    icon: "/images/chats.svg",
  },
  {
    name: "Manage Bids",
    href: "/manage-bids",
    icon: "/images/bids-circle.svg",
  },
  {
    name: "Bid Settings",
    href: "/bid-settings",
    icon: "/images/settings.svg",
  },
];

export const loadCategoriesMap: { [key: string]: string } = {
  freshProduce: "Fresh Produce",
  generalFreight: "General Freight",
  household: "Household",
  metalSheet: "Metal Sheet",
  motorVehicles: "Motor Vehicles",
  towaway: "Towaway",
  lumber: "Lumber",
  buildingMaterials: "Building Materials",
  mobileHomes: "Mobile Homes",
  machinery: "Machinery",
  liquidGases: "Liquid Gases",
  intermodal: "Intermodal",
  passengers: "Passengers",
  oilfieldEquipment: "Oilfield Equipment",
  livestock: "Livestock",
  grainFeedHay: "Grain Feed Hay",
  coal: "Coal",
  meat: "Meat",
  garbage: "Garbage",
  mail: "Mail",
  chemicals: "Chemicals",
  dryBulk: "Dry Bulk",
  refrigeratedFood: "Refrigerated Food",
  beverages: "Beverages",
  paperProducts: "Paper Products",
  utilities: "Utilities",
  agriculturalFarmSupplies: "Agricultural Farm Supplies",
  constructionHazmat: "Construction Hazmat",
  textile: "Textile",
  liquidBulk: "Liquid Bulk",
  cosmetics: "Cosmetics",
  electronics: "Electronics",
  garments: "Garments",
  waterWell: "Water Well",
  breakable: "Breakable",
  stoneware: "Stoneware",
  alcohol: "Alcohol",
};

// session cookie names come from the shared session package (the stage prefix
// is derived from the cookie parent domain: l5flt.com -> integ_,
// l5fleet.com -> preprod_, level5fleet.com -> prod_)
const SESSION_COOKIES = cookieNamesForDomain(process.env.REACT_APP_DOMAIN_NAME);

export const ACCESS_TOKEN_KEY: string = SESSION_COOKIES.idToken;
export const COOKIES_COMPANY_ID: string = SESSION_COOKIES.companyId;
export const COOKIES_USER_ID: string = SESSION_COOKIES.userId;
export const COOKIES_COMPANY_NAME: string = SESSION_COOKIES.companyName;
export const COOKIES_OTHER_APP_PROVISION: string = "fromProvision"; // from other app cookies
export const COOKIES_FROM_PROVISION: string = "fromProvisionTMU"; // from fleet cookies
export const COOKIES_LP: string = "trailerLp";
export const COOKIES_TRAILER_ID: string = "trailerId";
export const COOKIES_TMU_ID: string = "tmuId";

export const PAGE_LIMIT = 15;

export const WEBSOCKET_CLIENT_ACTIONS = {
  fetchNewChatMessages: "fetchNewChatMessages",
  fetchActiveChats: "fetchActiveChatMessages",
  fetchArchivedChats: "fetchArchivedChatMessages",
  sendMessage: "sendMessage",
  readMessage: "readMessage",
  archiveChat: "archiveChat",
  createChat: "createChat",
};

export const WEBSOCKET_RESPONSE_TYPE = {
  newChatMessages: "newChatMessages",
  allChatMessages: "activeChatMessages",
  newMessage: "newMessage",
  readMessage: "readMessage",
  newChatCreated: "newChatCreated",
  archivedChats: "archivedChatMessages",
  chatArchived: "chatArchived",
};

export const COMPANY_ROLE = {
  shipper: "shipper",
  carrier: "carrier",
  consignee: "consignee",
};
export const METRICS_URL = `${process.env.REACT_APP_API_URL}/public/emit-event`;
export const SESSION_ID_KEY = "s_id";
